//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createRefetchContainer } from "react-relay";
// suggestion-action-slack imports
import { IContainer, IProps } from "./SuggestionActionSlack.d";
import * as s from "./SuggestionActionSlack.styles";
import {
  suggestionActionSlackFragments,
  suggestionActionSlackQuery,
} from "./SuggestionActionSlack.gql";
// other components
import { CardButton } from "@components/card";
import { SlackButton } from "@components/slack-button";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import {
  openIntegrations,
  setSavedOnboardingChecklistSyncType,
  IOnboardingChecklistSyncType,
} from "@actions/settings.actions";
import { snackBarOpen } from "@actions/snack-bar.actions";
// util
import { track, TrackingEvents } from "@util/analytics.util";
// assets
import { slackIcon } from "@img/icons/";

//////////////////
// COMPONENT
//////////////////
class SuggestionActionSlackCmpt extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  // ~-~-~-~-~-~-~-
  // State Handling
  // ~-~-~-~-~-~-~-
  private getSlackAccountCount = (props: IProps) => {
    const settings = props.org && props.org.slackAccountsErrorable;
    if (!settings || settings.__typename === "GraphEntityError") {
      return 0;
    }
    return settings.list.length;
  };

  public UNSAFE_componentWillReceiveProps(props: IProps) {
    const prevAcccountCount = this.getSlackAccountCount(this.props);
    const nextAcccountCount = this.getSlackAccountCount(props);
    if (nextAcccountCount > prevAcccountCount) {
      track(TrackingEvents.SLACK.ADDED);
      this.props.snackBarOpen("Your Slack account was added!");
      this.props.setSavedOnboardingChecklistSyncType(IOnboardingChecklistSyncType.slackEnabled);
    }
  }

  // ~-~-~-~-~-~-~-
  // Click Handlers
  // ~-~-~-~-~-~-~-
  private onAuthPopupClosed = () => {
    this.props.relay.refetch({}, undefined, undefined, { force: true });
  };

  private onOpenSettings = () => {
    this.props.setSettingsDialogOpen(true);
    this.props.openIntegrations();
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  // helper for assembling the buttons
  private renderBtn = (label: string, action?: () => void, icon?: JSX.Element) => {
    return (
      <CardButton
        label={label}
        textColor={s.btnColor}
        onClick={() => action && action()}
        icon={icon}
        style={icon ? {} : { width: "inherit", display: "inline-block" }}
        flat
        isIconHTMLElement
      />
    );
  };

  // primary rendering
  public render() {
    const needsSlack = this.getSlackAccountCount(this.props) === 0;

    if (needsSlack) {
      const targetButton = this.renderBtn("Set up Slack", undefined, <img src={slackIcon} />);
      return (
        <SlackButton onAuthPopupClosed={() => this.onAuthPopupClosed()} target={targetButton} />
      );
    } else {
      return (
        <div>
          {this.renderBtn("Done", this.props.actionCallback)}
          {this.renderBtn("Settings", this.onOpenSettings)}
        </div>
      );
    }
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(_state: IReduxState, _ownProps: IContainer) {
  return {};
}

export const SuggestionActionSlack_redux = connect(mapStateToProps, {
  setSettingsDialogOpen,
  snackBarOpen,
  openIntegrations,
  setSavedOnboardingChecklistSyncType,
})(SuggestionActionSlackCmpt);

//////////////////
// RELAY
//////////////////
export const SuggestionActionSlack = createRefetchContainer<IContainer>(
  SuggestionActionSlack_redux,
  suggestionActionSlackFragments,
  suggestionActionSlackQuery,
);
